document.addEventListener("DOMContentLoaded", function () {
  const body = document.body;
  const headerOuter = document.querySelector(".header__outer");
  const headerHeight = headerOuter.clientHeight;

  const scrollUp = "scroll-up";
  const scrollDown = "scroll-down";
  let lastScroll = 0;

  // TODO: update name once settled
  const ONE_HUNDREDTH_OF_A_SECOND = 10;

  const handleScroll = debounce(() => {
    const currentScroll = window.pageYOffset;
    if (currentScroll <= 0) {
      body.classList.remove(scrollUp);
      return;
    }

    // TODO: give this some love
    // * might be ok
    if (currentScroll > headerHeight) {
      if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
        // down
        body.classList.remove(scrollUp);
        body.classList.add(scrollDown);
      } else if (
        currentScroll < lastScroll &&
        body.classList.contains(scrollDown)
      ) {
        // up
        body.classList.remove(scrollDown);
        body.classList.add(scrollUp);
      }
      // for case of slight scroll that removes header and does not add it back
    } else if (
      currentScroll < headerHeight &&
      body.classList.contains(scrollDown)
    ) {
      body.classList.remove(scrollDown);
      body.classList.add(scrollUp);
    }
    lastScroll = currentScroll;
  }, ONE_HUNDREDTH_OF_A_SECOND);

  window.addEventListener("scroll", handleScroll);
});

const debounce = (callback, wait) => {
  let timeoutId = null;
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback.apply(null, args);
    }, wait);
  };
};
